import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import meter1 from '../assests/img/meter1.svg';
import meter2 from '../assests/img/meter2.svg';
import meter3 from '../assests/img/meter3.svg';
import colorSharp from "../assests/img/color-sharp.png";

export const Skills = () => {
    const responsive = {
        superLargeDesktop: {
          
          breakpoint: { max: 4000, min: 3000 },
          items: 5
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 3
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 2
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1
        }
      };

  return (
   <>
   <section className='skill' id='skills'>
    <Container>
        <Row>
            <Col>
            <div className='skill-bx'>
                <h2>Skills</h2>
                <p>My expertise includes React.js, JavaScript, HTML, and CSS, along with proficiency in state management, component-based architecture, and responsive design. I am also experienced in integrating APIs and optimizing front-end performance for scalable applications.</p>
                <Carousel responsive={responsive} infinite={true} className='skill-slider'>
                    <div className='item'>
                        <img src={meter1} alt='image' ></img>
                        <h5>HTML5</h5>
                    </div>
                    <div className='item'>
                        <img src={meter1} alt='image' ></img>
                        <h5>CSS3</h5>
                    </div>
                    <div className='item'>
                        <img src={meter2} alt='image' ></img>
                        <h5>React.js</h5>
                    </div>
                    <div className='item'>
                        <img src={meter2} alt='image' ></img>
                        <h5>Tailwind CSS</h5>
                    </div>
                    <div className='item'>
                        <img src={meter3} alt='image' ></img>
                        <h5>JavaScript</h5>
                    </div>
                    <div className='item'>
                        <img src={meter3} alt='image' ></img>
                        <h5>TypeScript</h5>
                    </div>
                    <div className='item'>
                        <img src={meter2} alt='image' ></img>
                        <h5>Web Developer</h5>
                    </div>
                    <div className='item'>
                        <img src={meter1} alt='image' ></img>
                        <h5>Web Designer</h5>
                    </div>
                    <div className='item'>
                        <img src={meter3} alt='image' ></img>
                        <h5>Java Developer</h5>
                    </div>
                </Carousel>
            </div>
            </Col>
        </Row>
    </Container>
    <img src={colorSharp} className='background-image-left'></img>
   </section>
   </>
  
  )
}
